import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import { EmptyState } from '@/components/custom/empty-state';

export const CourseClassroomExamEmpty = props => {
  const navigate = useNavigate();
  const client = useClient();
  const { unfinishedExam } = props;
  const [unfinishedQuestionBook, setUnfinishedQuestionBook] = useState({});

  const getQuestionBook = async () => {
    const { data } = await client.fetch(`question_books/${unfinishedExam?.id}`);
    setUnfinishedQuestionBook(data);
  };

  useEffect(() => {
    getQuestionBook();
  }, [unfinishedExam]);

  return (
    <>
      {unfinishedQuestionBook?.visibility !== 'train' && (
        <EmptyState
          variant="plain"
          type="content"
          title="Chegou a hora de colocar em prática o que você aprendeu."
          text="Em instantes você realizará uma prova sobre os conteúdos estudados até aqui. Boa sorte!"
          cta={{ text: 'Acessar a prova', onClick: () => navigate(`/avaliacoes/sobre/${unfinishedExam?.id}`) }}
        />
      )}

      {unfinishedQuestionBook?.visibility === 'train' && (
        <EmptyState
          variant="plain"
          type="content"
          title="Chegou a hora de colocar em prática o que você aprendeu."
          text="Em instantes você realizará um exercício sobre os conteúdos estudados até aqui. Boa sorte!"
          cta={{ text: 'Acessar o exercício', onClick: () => navigate(`/questions/apostilas/${unfinishedExam?.id}`) }}
        />
      )}
    </>
  );
};
